import { render, staticRenderFns } from "./AnchorPage.vue?vue&type=template&id=8be4b4d0&scoped=true"
import script from "./AnchorPage.vue?vue&type=script&lang=js"
export * from "./AnchorPage.vue?vue&type=script&lang=js"
import style0 from "./AnchorPage.vue?vue&type=style&index=0&id=8be4b4d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be4b4d0",
  null
  
)

export default component.exports